export default (ajv) => {
  ajv.addKeyword({
    keyword: 'isFunction',
    schemaType: 'string',
    error: { message: 'Must be a function' },
    compile(schema, parent) {
      return (data) => typeof data === 'function';
    }
  });

  ajv.addKeyword({
    keyword: 'isNullableFunction',
    schemaType: 'string',
    error: { message: 'Must be a function or null' },
    compile(schema, parent) {
      return (data) => !data || (typeof data === 'function');
    }
  });
};
